import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20industry%20spotlight%20stage%2C%20dark%20moody%20theater%20atmosphere%2C%20red%20and%20black%20color%20palette%2C%20mysterious%20smoke%20and%20light%20beams%2C%20cinematic%20cinematic%20noir%20photography%20style%2C%20abstract%20celebrity%20silhouettes%20in%20shadows&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="51吃瓜网站首屏背景"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      <div className="relative z-10 container-custom text-center pt-20 md:pt-24">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 md:mb-6">
          <span className="block">51吃瓜网站</span>
          <span className="block mt-1 md:mt-2 text-primary-400">今日黑料大瓜全纪录</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          聚合全网最新黑料吃瓜，直击网红明星塌房现场。
          <br className="hidden sm:block" />
          独家资源集散第一站，实时追踪不间断。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/jinri-dagua"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            今日大瓜
          </Link>
          <Link
            to="/category/mingxing-heiliao"
            className="px-6 py-3 rounded-full bg-white/15 text-background-50 font-medium text-sm md:text-base hover:bg-white/25 backdrop-blur-sm transition-colors whitespace-nowrap"
          >
            明星黑料
          </Link>
        </div>

        <div className="mt-10 md:mt-14 flex items-center justify-center gap-6 md:gap-10 text-background-300 text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20 text-primary-400">
              <i className="ri-fire-line" />
            </span>
            <span>实时更新</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-400">
              <i className="ri-shield-check-line" />
            </span>
            <span>实锤爆料</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/20 text-secondary-400">
              <i className="ri-global-line" />
            </span>
            <span>全网聚合</span>
          </div>
        </div>
      </div>
    </section>
  );
}